import stores from '🔗/stores';
import useNavStore from '@/stores/nav';

import { message } from '🔗/utils/utils';

const controllers = {};

const signal = (name, id) => {
    const code = id ? `${name}_${id}` : name;

    if (controllers[code]) {
        controllers[code].abort();
    }

    controllers[code] = new AbortController();

    return controllers[code].signal;
};

const clean = (name) => {
    if (controllers[name]) {
        controllers[name].abort();
    }

    delete controllers[name];
};

const abort = (name, id) => {
    if (id) {
        clean(`${name}_${id}`);
    } else {
        Object.keys(controllers)
            .filter((item) => item.indexOf(`${name}_`) === 0)
            .forEach((code) => {
                clean(code);
            });
    }
};

export const requests = {
    signal,
    abort
};

let showAuthErrorTimeout;

export const onRequestDefaultError = (e) => {
    const t = stores.locale().t();

    if (e?.code !== 'ERR_CANCELED') {
        if (e?.code === 'ERR_NETWORK') {
            window.location.reload();
        } else if (e?.response?.status === 401) {
            clearTimeout(showAuthErrorTimeout);
            showAuthErrorTimeout = setTimeout(() => {
                message.error(t('utils.request.authError'));
            }, 200);

            if (useNavStore().page !== 'login') {
                stores.user().logout();
                useNavStore().open('login');
            }
        } else if (e?.response?.status === 422) {
            if (useNavStore().page !== 'access-denied') {
                useNavStore().open('access-denied');
            }
        } else if (e?.response?.status === 423) {
            message.error(e.response?.data?.message || t('utils.request.error'));
        } else {
            message.error(t('utils.request.error'));
        }
    }
};

export const removeNulls = (data) => {
    if (!data) {
        return null;
    }

    Object.keys(data).forEach(key => {
        if (data[key] === null) {
            delete data[key];
        }
    });

    return data;
};